// extracted by mini-css-extract-plugin
module.exports = {"product":"Products_product_3zGr8"};